import React from 'react';
import { Button, Image } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { shitchThemeMode } from 'actions';

const Mode = () => {

  const dispatch = useDispatch();
  const themeState = useSelector(state => state.themeState);


  const handleDarkMode = () => { dispatch(shitchThemeMode('dark')); }
  const handleLightMode = () => { dispatch(shitchThemeMode('light')); }

  return (
    <div className="modes d-flex align-items-center justify-content-center">
      <Button
        className={`p-1 px-2 me-1 border-0 ${themeState.themeMode === 'dark' ? 'light-mode-btn' : ''}`}
        variant='none'
        onClick={handleDarkMode}
      >
        <Image src={themeState.themeMode === 'dark' ? '/assets/images/moon-dark.svg' : '/assets/images/dark-mode.svg'} />
      </Button>
      <Button
        className={`p-1 px-2 border-0 ${themeState.themeMode === 'light' ? 'light-mode-btn' : ''}`}
        variant='none'
        onClick={handleLightMode}
      >
        <Image src={themeState.themeMode === 'dark' ? '/assets/images/sun-dark.svg' : '/assets/images/sun-dark.svg'} />
      </Button>
    </div>
  );
};

export default Mode;
